// @flow

import { Lock, PenLine } from 'lucide-react';

import { PillButton } from 'src/components/PillButton';

export function SetupPill({
  children,
  to,
  disabled = false,
}: {
  children: string | React.MixedElement,
  to?: string,
  disabled?: boolean,
}): React.MixedElement {
  const enabled = !disabled && !!to;

  const icon = enabled ? <PenLine size={12} /> : <Lock size={12} />;

  return (
    <PillButton to={to} disabled={!enabled}>
      {children}
      {icon}
    </PillButton>
  );
}
